import React from 'react'
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"

function PracticeChart({data}) {
    const chartData = [
        { date: "2025-02-21", highScore: 30, avgScore: 10 },
        { date: "2025-02-22", highScore: 62, avgScore: 46 },
        { date: "2025-02-23", highScore: 115, avgScore: 85 },
        { date: "2025-02-24", highScore: 95, avgScore: 48 },
        { date: "2025-02-25", highScore: 125, avgScore: 65 },
        { date: "2025-02-26", highScore: 165, avgScore: 180 },
        { date: "2025-02-27", highScore: 105, avgScore: 70 },
        { date: "2025-02-28", highScore: 142, avgScore: 100 },
        { date: "2025-02-29", highScore: 101, avgScore: 71 },
        { date: "2025-02-30", highScore: 95, avgScore: 20 },
        
      ]
    
    //   const testData = [
    //     { week: "2025-W11", user: 130, test: 285 },
    //     { week: "2025-W10", user: 232, test: 296 },
    //     { week: "2025-W24", user: 15, test: 87 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //     { week: "2025-W01", user: 285, test: 187 },
    //   ]
    
    //   const chartMonth = [
    //     { month: "April 2025", user: 130, test: 285 },
    //     { month: "May 2024", user: 232, test: 296 },
    //     { month: "June 2024", user: 15, test: 87 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 2085, test: 187 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 285, test: 1807 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 285, test: 187 },
    //     { month: "January 2025", user: 285, test: 187 },
    //   ]
    //   console.log("chart data", chartData)
      const labels = data.map(item => item.date)
      const highScore = data.map(item => item.highScore)
      const avgScore = data.map(item => item.avgScore)
    
      const chartOptions = {
        chart: {
          type: "spline",
        },
        title: {
          text: "Practice Scores ", // Remove chart title
        },
        credits: {
          enabled: false, // Remove Highcharts watermark
        },
        xAxis: {
          categories: labels,
          title: {
            text:  "",
          },
        },
        
    
        tooltip: {
          shared: true,
          valueSuffix: "",
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: true,
          },
        },
        series: [
          {
            name: "High Score",
            data: highScore,
            color: "#2196F3", // Line color
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, "rgba(33, 149, 243, 0.29)"],
                [1, "rgba(33, 149, 243, 0)"],
              ],
            },
          },
          {
            name: "Average Score",
            data: avgScore,
            color: "#dd0da5",
            fillColor: {
              linearGradient: [0, 0, 0, 300],
              stops: [
                [0, "rgba(240, 8, 179, 0.64)"], // Top of the area
                [1, "rgba(244, 117, 210, 0)"],
                // [1, "rgba(244, 117, 210, 0.68)"],
              ],
            },
          },
        ],
      }
    console.log("data from crowd chart", data)
  return (
    <div>
       <div className='border border-gray-300 rounded-lg '>
       <Card>
                <CardBody>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                  />
                </CardBody>
              </Card>
      </div>
    </div>
  )
}

export default PracticeChart
